<template>
  <div class="row page-content-wrapper">
    <div class="col-12">
      <page-header>
        <template slot="action-buttons">
          <a
            v-if="isCompleted"
            class="zip-link"
            :href="`${localBasePath}/api/v1/reports/case/${$route.params.id}/zip?authorization=${access_token_link}`"
            target="_blank"
          >
            {{ 'Download zip' | i18n }}
          </a>
        </template>
      </page-header>
      <div class="row">
        <div class="col-12 main-content">
          <data-table ref="table" v-model="table" :get-page="getPage" :per-page="50" :has-details-row="false">
            <template #head(status)="row">
              {{ row.label }}
              <table-filer v-model="table.filter.status" input-type="select" :filter-options="statusOptions" />
            </template>
            <template #head(teamName)="row">
              {{ row.label }}
              <table-filer v-model="table.filter.teamName" input-type="text" />
            </template>
            <template #cell(status)="row">
              <b-badge class="status-badge" :variant="getStatusBadgeVariant(row.item.status)">
                {{ row.item.status | i18n }}
              </b-badge>
            </template>
            <template #cell(id)="row">
              {{ row.item.id.slice(0, 10) }}
            </template>
            <template #cell(createdAt)="row">
              {{ row.item.createdAt | formatDate('DD.MM.YY HH:mm') }}
            </template>
            <template #cell(updatedAt)="row">
              {{ row.item.updatedAt | formatDate('DD.MM.YY HH:mm') }}
            </template>
            <template #cell(actions)="row">
              <div class="actions-block">
                <b-button class="edit-row-button mr-2 mb-1 d-inline-block" variant="outline-primary" size="sm" @click="goToReport(row.item)">
                  {{ 'Details' | i18n }}
                </b-button>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import { ReportsMixin, NotificationMixin, BaseTableComponentMixin, DeleteRowMixin, AuthMixin, ApiMixin, AuthStorageMixin } from '../../../mixins';
import DataTable from '../../table/data-table';
import PageHeader from '../../structure/page-header';
import { BBadge } from 'bootstrap-vue';
import TableFiler from '../../table/table-filter';
import { ROLES, REPORT_STATUSES } from '../../../../../../constants';

export default {
  name: 'Cases',
  components: { PageHeader, DataTable, BBadge, TableFiler },
  mixins: [ReportsMixin, NotificationMixin, BaseTableComponentMixin, DeleteRowMixin, AuthMixin, ApiMixin, AuthStorageMixin],
  data: function () {
    return {
      statuses: REPORT_STATUSES,
      statusOptions: Object.values(REPORT_STATUSES).map((item) => ({
        value: item,
        text: this.$translate(item),
      })),
      roles: ROLES,
      isCompleted: false,
      access_token_link: '',
    };
  },
  computed: {
    localBasePath: function () {
      return axios.defaults.baseURL;
    },
  },
  created() {
    const auth = this.authStorageService.getAuth();
    this.access_token_link = auth.access_token_link;

    this.table.fields = [
      { key: 'id', label: '#', thClass: 'w70', tdClass: 'w70', sortable: true },
      { key: 'status', label: this.$translate('status'), thClass: 'w100', tdClass: 'w100' },
      { key: 'team.name', label: this.$translate('team'), thClass: 'width-15', tdClass: 'width-15' },
      { key: 'title', label: this.$translate('title'), thClass: 'w100', tdClass: 'w100' },
      { key: 'user.email', label: this.$translate('user'), thClass: 'width-20', tdClass: 'width-20' },
      { key: 'template.name', label: this.$translate('template'), thClass: 'width-20', tdClass: 'width-20' },
      { key: 'createdAt', label: this.$translate('created_date'), thClass: 'w100', tdClass: 'w100', sortable: true },
      { key: 'updatedAt', label: this.$translate('updated_date'), thClass: 'w120', tdClass: 'w120', sortable: true },
      { key: 'actions', label: this.$translate('actions'), tdClass: 'actions-w250', thClass: 'actions-w250' },
    ];

    this.table.filter = { status: null, teamName: null };
    this.table.sortBy = 'createdAt';
    this.table.sortOrder = 'desc';
  },
  methods: {
    async getPage(ctx) {
      const response = await this.reportsService.getReportsPage(ctx, this.$route.params.id);
      this.isCompleted = response.data.some((i) => i.status === REPORT_STATUSES.COMPLETED);
      return response;
    },
    goToReport(item) {
      console.log(item, 'item');
      this.$router.push({ name: 'report-details', params: { id: item.id } });
    },
    getStatusBadgeVariant(status) {
      switch (status) {
        case this.statuses.IN_PROGRESS:
          return 'info';
        case this.statuses.COMPLETED:
          return 'secondary';
        default:
          return 'secondary';
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .zip-link {
  cursor: pointer;
  color: white;
  background: linear-gradient(#2260ff, #2260ff);
  border-radius: 4px;
  border: none;
  padding: 6px 12px;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.5;
  display: inline-block;
  outline: none;
}

::v-deep .zip-link:hover {
  border: none;
  background: linear-gradient(180deg, #2260ff 0%, rgba(34, 96, 255, 0.75) 100%) !important;
  color: #fff;
  text-decoration: none;
}

::v-deep .b-table-sticky-header {
  max-height: calc(100vh - 230px);
  min-height: calc(100vh - 230px);
}

::v-deep .table {
  min-width: 1200px;

  .edit-row-button {
    font-size: 14px !important;
    padding: 4px 4px;
  }

  th,
  td {
    &.actions {
      .actions-block {
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: center;
        button {
          display: block;
        }
      }
    }

    &.width-10 {
      width: 10%;
    }

    &.width-15 {
      width: 15%;
    }

    &.width-20 {
      width: 20%;
    }
    &.w50 {
      width: 50px !important;
    }
    &.w70 {
      width: 70px !important;
    }
    &.w100 {
      width: 100px !important;
    }
    &.w120 {
      width: 120px !important;
    }
    &.w180 {
      width: 180px !important;
    }
    &.actions-w250 {
      width: 250px !important;
    }
  }

  .status-badge {
    font-size: 90%;
    width: 60px;
  }
}
</style>
